export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_6-b81f9cf02e5a4d7c2ce9d79da99c8532.jpg";